<template>
  <div class="text-xs-center">
    <img
      class="payment_img payment-error_img"
      src="/img/icons/redcross.png"
    />
    <h2 class="payment_title">{{$t('pay.error.title')}}</h2>
    <h3 class="payment_subtitle">{{$t('pay.error.subtitle')}}</h3>
    <p class="payment_text">{{$t('pay.error.text')}} <a href="mailto:team_rh@robinhood-tierschutz.at">team_rh@robinhood-tierschutz.at</a>
    </p>
    <v-btn
      :to="{ name: 'UserAnimals' }"
      color="primary"
    >
      {{$t('pay.error.button')}}
    </v-btn>
  </div>
</template>

<script>
  export default {
    name: 'Success',
  };
</script>

<style lang="scss" scoped>
  .payment {
    &_img {
      height: 150px;
      width: 150px;
      margin: 20px 0;
    }

    &-error {
      &_img {
        transform: rotate(45deg);
      }
    }

    &_subtitle {
      font-weight: bold;
      font-size: 24px;
      line-height: 28px;
      color: rgba(0, 0, 0, 0.65);
    }

    &_text {
      font-size: 20px;
      line-height: 24px;
      color: rgba(0, 0, 0, 0.65);
      margin: 20px auto;
      width: 45%;
    }
  }
</style>
